import apiClient from "@toothfairy/shared-api/apiClient";
import secureRequest from "@toothfairy/shared-api/secureAPI";
import AppAuth from "@toothfairy/shared-ui/AppAuthScreen";
import envConfig from "../../../envConfig";

const registerTelegramWebhook = async ({ workspace_id, channel_id }) => {
  const payload = await AppAuth.getCurrentSession();
  const url = `${envConfig.REACT_APP_REST_ENDPOINT}/channels/telegram/webhook`;
  const requestBody = {
    workspace_id,
    channel_id,
  };
  return secureRequest(
    apiClient.apiClient,
    "POST",
    url,
    null,
    requestBody,
    true,
    null,
    payload,
  );
};

const getTelegramWebhookInfo = async ({ workspace_id, channel_id }) => {
  const payload = await AppAuth.getCurrentSession();
  const url = `${envConfig.REACT_APP_REST_ENDPOINT}/channels/telegram/webhook`;
  const requestBody = {
    workspace_id,
    ...(channel_id && { channel_id }),
  };
  return secureRequest(
    apiClient.apiClient,
    "GET",
    url,
    null,
    requestBody,
    true,
    null,
    payload,
  );
};

const deleteTelegramWebhook = async ({ workspace_id, channel_id }) => {
  const payload = await AppAuth.getCurrentSession();
  const url = `${envConfig.REACT_APP_REST_ENDPOINT}/channels/telegram/webhook`;
  const requestBody = {
    workspace_id,
    ...(channel_id && { channel_id }),
  };
  return secureRequest(
    apiClient.apiClient,
    "DELETE",
    url,
    null,
    requestBody,
    true,
    null,
    payload,
  );
};

export default {
  registerTelegramWebhook,
  getTelegramWebhookInfo,
  deleteTelegramWebhook,
};
